import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Idea = function Idea(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M25 0h-2v5h2V0ZM46 19h-5v2h5v-2ZM7 19H2v2h5v-2ZM28 41.995v-2L20 40v2l8-.004ZM13.31 8.896 9.104 4.69 7.69 6.103l4.207 4.208 1.415-1.415ZM40.31 6.103 38.898 4.69l-4.208 4.207 1.414 1.414 4.208-4.207Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M26 48h-4c-1.65 0-3-1.35-3-3v-3.688L11.85 30.8C9.988 28.25 9 25.2 9 22c0-8.275 6.725-15 15-15s15 6.725 15 15c0 3.188-.987 6.238-2.862 8.813L29 41.3V45c0 1.65-1.35 3-3 3ZM24 9c-7.163 0-13 5.838-13 13 0 2.775.863 5.413 2.488 7.637L21 40.688V45c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-4.313l7.5-11.024c1.638-2.25 2.5-4.9 2.5-7.663 0-7.162-5.837-13-13-13Z",
      fill: color
    })]
  });
};
export default Idea;